import {
  formatMoneyValue,
  formatPercentageValue,
  parseDollarStrToNumber,
} from "../functions/permitFormHelpers";

const toFormulaNumber = (value) => {
  const parsed = parseDollarStrToNumber(value);
  const number = Number.parseFloat(parsed ?? 0);

  return Number.isFinite(number) ? number : 0;
};

const getFormulaStepValue = (formulaField, valuesByName) => {
  const fieldName = formulaField?.field?.name;
  const value = fieldName ? valuesByName?.[fieldName] : formulaField?.value;

  return toFormulaNumber(value);
};

export const evaluateFormulaFields = (formulaFields, valuesByName = {}) => {
  if (!Array.isArray(formulaFields) || formulaFields.length === 0) {
    return undefined;
  }

  let result = getFormulaStepValue(formulaFields[0], valuesByName);

  for (let index = 1; index < formulaFields.length; index += 1) {
    const formulaField = formulaFields[index];
    const value = getFormulaStepValue(formulaField, valuesByName);

    switch (formulaField?.operator?.value) {
      case "+":
        result += value;
        break;
      case "-":
        result -= value;
        break;
      case "*":
        result *= value;
        break;
      case "/":
        if (value !== 0) result /= value;
        break;
      case "=":
        result = value;
        break;
      case "%":
        result *= value / 100;
        break;
      default:
        break;
    }
  }

  return result;
};

export const formatFormulaResult = (result, usePercentage = false) => {
  if (result === undefined || !Number.isFinite(result)) return undefined;

  return usePercentage
    ? formatPercentageValue(result === 0 ? "0" : result)
    : formatMoneyValue(result === 0 ? "0" : result);
};

export const calculateFormulaValue = ({
  formulaFields,
  valuesByName,
  usePercentage = false,
}) =>
  formatFormulaResult(
    evaluateFormulaFields(formulaFields, valuesByName),
    usePercentage,
  );

export const getFormulaUpdate = ({
  currentValue,
  formulaFields,
  valuesByName,
  usePercentage = false,
}) => {
  const computedValue = calculateFormulaValue({
    formulaFields,
    valuesByName,
    usePercentage,
  });

  return computedValue === undefined || currentValue === computedValue
    ? undefined
    : computedValue;
};